export default __webpack_public_path__ + "static/media/RePack_logo_text_transparent.dfe2feba.png";